<template>
    <div>
      <h5>Payment Details</h5>
      <template v-if="payment && payment.length">
        <table class="table">
          <thead>
            <tr>
              <th>Payment ID</th>
              <th>Account ID</th>
              <th>User Name</th>
              <th>Teacher NIC</th>
              <th>Status</th>
              <th>Payment Date</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(paymentItem, index) in payment" :key="index">
              <td>{{ paymentItem.id }}</td>
              <td>{{ paymentItem.account_id }}</td>
              <td>{{ paymentItem.user.first_name }}</td>
              <td>{{ paymentItem.teacher.teacher_nic }}</td>
              <td>{{ paymentItem.account_status.status_name }}</td>
              <td>{{ paymentItem.payment_date }}</td>
              <td>{{ paymentItem.payment_price }}</td>
            </tr>
          </tbody>
        </table>
      </template>
      <p v-else>No payment details available.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ViewPayment',
    props: {
      payment: {
        type: Array,
        default: () => [],
      },
    },
  };
  </script>
  
  <style scoped>
  .table {
    width: 100%;
  }
  </style>
  